import LegalPage from '@/components/feature/LegalPage';

const sections = [
  {
    title: '协议的接受',
    paragraphs: [
      '欢迎使用天天漫画提供的相关服务。当您下载、安装或以任何方式使用天天漫画客户端及网站服务时，即表示您已充分阅读、理解并同意接受本《用户协议》的全部内容。',
      '如果您不同意本协议的任何条款，请立即停止使用天天漫画的相关服务。您对本协议的接受，亦视为您已同意我们按照《隐私政策》处理您的个人信息。',
    ],
  },
  {
    title: '账号注册与管理',
    paragraphs: [
      '您在使用天天漫画服务前，需要注册一个账号。您应当提供真实、准确、完整的注册信息，并在信息发生变化时及时更新。您有责任妥善保管账号及密码，并对通过该账号进行的一切活动承担责任。',
      '如您发现账号存在被盗用或未经授权的使用，应立即通知我们。对于因您自身原因导致账号信息泄露而造成的损失，我们将在法律允许的范围内承担相应责任。',
    ],
  },
  {
    title: '服务的变更、中断与终止',
    paragraphs: [
      '为持续提升服务质量，我们可能对服务内容进行更新或调整，并适时通过公告等方式通知您。如因不可抗力、网络故障或其他非我们可控的原因导致服务中断，我们将在合理范围内尽力恢复。',
      '如您违反本协议或相关法律法规，我们有权视情节轻重采取包括但不限于警告、限制功能、暂停或终止服务等措施。',
    ],
  },
  {
    title: '其他约定',
    paragraphs: [
      '本协议的订立、执行与解释均适用中华人民共和国法律。因本协议引起的争议，双方应友好协商解决；协商不成的，任何一方均可向有管辖权的人民法院提起诉讼。',
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      title="用户协议"
      subtitle="请在使用前仔细阅读并了解您与天天漫画之间的权利义务。"
      updatedAt="2026年8月30日"
      sections={sections}
    />
  );
}